import React, { PropsWithChildren, } from 'react';

import ReactDOMServer from 'react-dom/server';
import { isArray, isObject } from './ObjectUtils';

export interface IFillLayoutProps {
    layout?: any;
    context?: object;
}
function evalInContext(context, funcText) {
    //# Return the results of the in-line anonymous function we .call with the passed context
    return function () { return eval(funcText); }.call(context);
}

const extractFunc = (context, text) => {
    let func;
    let str;
    try {
        func = evalInContext(context, text);
    } catch (ex) {
        console.log(str, ex);
    };
    if (typeof (func) != "function") {
        str = "()=>" + text + "";
        try {
            func = evalInContext(context, str);
        } catch (ex) {
            console.log(str, ex);
        };
    }
    if (typeof (func) == "function") {
        return func;
    }
    else {
        return null;
    }
}

const getFuncResult = (context, text) => {
    let result = extractFunc(context, text)();
    return result;
}
//const FillLayout = (fillLayoutProps: IFillLayoutProps) => {
const FillLayout: React.FC<PropsWithChildren<IFillLayoutProps>> = ({...props}) => {

//const FillLayout = ({ layout, context }) => {
    const fillLayoutProps = props;
    const layout = fillLayoutProps.layout;
    const context = fillLayoutProps.context;
//    layout = (layout || "").toString();
    const getKeyList = () => {
        const res = layout.match(/{{(.*?)}}/gms);
        return res;
    }
    let someHtml = layout;
    (getKeyList() || []).forEach(
        element => {
            let elementName = element.slice(2, element.length - 2).trim();
            try {
                console.log("context", context);
                const funcResult = getFuncResult(context, elementName);
                console.log("funcResult", funcResult);
                const renderToStaticMarkup = ReactDOMServer.renderToStaticMarkup;
//                const renderToString = ReactDOMServer.renderToString;
//                let test = renderToStaticMarkup(funcResult);
                let test;
                if (isObject(funcResult) || isArray(funcResult)) {
                    test = JSON.stringify(funcResult);
                }
                else {
                    test = funcResult;
                }
//                test = renderToString(funcResult);
                someHtml = someHtml.replaceAll(element, test);
            }
            catch (e) {
                console.error(e);
            }
        }
    )
    console.log(someHtml);
    const result = <div className="layout-container" dangerouslySetInnerHTML={{ __html: someHtml }}></div>
    return result;
}

export default FillLayout;